export const REGIONS = [
  "US East (N. Virginia)",
  "US West (Oregon)",
  "Asia Pacific (Mumbai)",
];

export const PRICING_MODELS = ["On-Demand", "Reserved"];

export const OS_TYPES = ["Linux", "Windows"];

export const TIME_UNITS = ["Per Hour", "Per Month"];

export const timeUnitOptions = [
  { value: "Per Hour", label: "Per Hour" },
  { value: "Per Day", label: "Per Day" },
  { value: "Per Month", label: "Per Month" },
  { value: "Per Year", label: "Per Year" },
];

export const BASE_URLS: Record<string, string> = {
  aws: "/api/aws/ec2/instances",
  gcp: "/api/gcp/compute/instances",
  azure: "/azure-api/price", // ⚡ Azure goes through its own proxy
};
export const DIRECT_BASE_URLS: Record<string, string> = {
  aws: "/aws/ec2/instances",
  gcp: "/gcp/compute/instances",
  azure: "/price", // ⚡ Azure goes through its own proxy
};
export const SUBSCRIPTION_KEY = "f21469afd25e46c48f4056511ebe67ba";

export const paymentTypes = {
  aws: [
    { label: "On Demand", value: "OnDemand" },
    { label: "Spot", value: "Spot" },
    {
      label: "1yr Reserved - No Upfront",
      value: "Reserved1yrStandardNoUpfront",
    },
    {
      label: "1yr Reserved - Partial Upfront",
      value: "Reserved1yrStandardPartialUpfront",
    },
    {
      label: "1yr Reserved - All Upfront",
      value: "Reserved1yrStandardAllUpfront",
    },
    {
      label: "3yr Reserved - No Upfront",
      value: "Reserved3yrStandardNoUpfront",
    },
    {
      label: "3yr Reserved - Partial Upfront",
      value: "Reserved3yrStandardPartialUpfront",
    },
    {
      label: "3yr Reserved - All Upfront",
      value: "Reserved3yrStandardAllUpfront",
    },
    {
      label: "1yr Convertible - No Upfront",
      value: "Reserved1yrConvertibleNoUpfront",
    },
    {
      label: "1yr Convertible - Partial Upfront",
      value: "Reserved1yrConvertiblePartialUpfront",
    },
    {
      label: "1yr Convertible - All Upfront",
      value: "Reserved1yrConvertibleAllUpfront",
    },
    {
      label: "3yr Convertible - No Upfront",
      value: "Reserved3yrConvertibleNoUpfront",
    },
    {
      label: "3yr Convertible - Partial Upfront",
      value: "Reserved3yrConvertiblePartialUpfront",
    },
    {
      label: "3yr Convertible - All Upfront",
      value: "Reserved3yrConvertibleAllUpfront",
    },
  ],
  gcp: [
    { label: "On Demand", value: "OnDemand" },
    { label: "Spot (Preemptible VM)", value: "Spot" },
    { label: "1-Year Commitment", value: "Commit1Yr" },
    { label: "3-Year Commitment", value: "Commit3Yr" },
    { label: "Sustained Use 50%", value: "SustainedDiscounts50" },
    { label: "Sustained Use 75%", value: "SustainedDiscounts75" },
    { label: "Sustained Use 100%", value: "SustainedDiscounts100" },
  ],
  azure: [
    { label: "Pay As You Go", value: "payasyougo" },
    { label: "Reserved 1-Year", value: "reserved1y" },
    { label: "Reserved 3-Year", value: "reserved3y" },
    { label: "Savings Plan 1-Year", value: "savingsplan1y" },
    { label: "Savings Plan 3-Year", value: "savingsplan3y" },
  ],
};
export const operatingSystems = {
  aws: [
    { label: "Linux/Unix", value: "Linux" },
    { label: "Red Hat Enterprise Linux", value: "RHEL" },
    { label: "SUSE Linux", value: "SUSE" },
    { label: "Ubuntu", value: "Ubuntu" },
    { label: "Windows", value: "Windows" },
    { label: "Debian", value: "Debian" },
    { label: "CentOS", value: "CentOS" },
  ],
  gcp: [
    { label: "Debian", value: "Debian" },
    { label: "CentOS", value: "CentOS" },
    { label: "Ubuntu", value: "Ubuntu" },
    { label: "SUSE Linux Enterprise Server", value: "SLES" },
    { label: "Red Hat Enterprise Linux", value: "RHEL" },
    { label: "Rocky Linux", value: "Rocky" },
    { label: "Windows Server", value: "Windows" },
    { label: "Container-Optimized OS", value: "COS" },
  ],
  azure: [
    { label: "Windows", value: "Windows" },
    { label: "Linux", value: "Linux" },
    { label: "Ubuntu", value: "Ubuntu" },
    { label: "Red Hat Enterprise Linux", value: "RHEL" },
    { label: "SUSE Linux Enterprise", value: "SLES" },
    { label: "CentOS", value: "CentOS" },
    { label: "Debian", value: "Debian" },
  ],
};

export const compareRegions = [
  {
    name: "US East",
    aws: { label: "US East (N. Virginia)", value: "us-east-1" },
    gcp: { label: "South Carolina, USA", value: "us-east1" },
    azure: { label: "East US", value: "eastus" },
  },
  {
    name: "US East (Ohio)",
    aws: { label: "US East (Ohio)", value: "us-east-2" },
    gcp: { label: "Northern Virginia, USA", value: "us-east4" },
    azure: { label: "East US 2", value: "eastus2" },
  },
  {
    name: "US Central",
    aws: { label: "US West (Oregon)", value: "us-west-2" },
    gcp: { label: "Iowa, USA", value: "us-central1" },
    azure: { label: "Central US", value: "centralus" },
  },
  {
    name: "US West",
    aws: { label: "US West (N. California)", value: "us-west-1" },
    gcp: { label: "Oregon, USA", value: "us-west1" },
    azure: { label: "West US", value: "westus" },
  },
  {
    name: "US West (Pacific)",
    aws: { label: "US West (Oregon)", value: "us-west-2" },
    gcp: { label: "Los Angeles, USA", value: "us-west2" },
    azure: { label: "West US 2", value: "westus2" },
  },
  {
    name: "Canada",
    aws: { label: "Canada (Central)", value: "ca-central-1" },
    gcp: { label: "Montréal, Canada", value: "northamerica-northeast1" },
    azure: { label: "Canada Central", value: "canadacentral" },
  },
  {
    name: "Europe (Ireland/UK)",
    aws: { label: "Europe (Ireland)", value: "eu-west-1" },
    gcp: { label: "London, UK", value: "europe-west2" },
    azure: { label: "UK South", value: "uksouth" },
  },
  {
    name: "Europe (Germany)",
    aws: { label: "Europe (Frankfurt)", value: "eu-central-1" },
    gcp: { label: "Frankfurt, Germany", value: "europe-west3" },
    azure: { label: "Germany West Central", value: "germanywestcentral" },
  },
  {
    name: "Europe (France)",
    aws: { label: "Europe (Paris)", value: "eu-west-3" },
    gcp: { label: "Finland", value: "europe-north1" },
    azure: { label: "France Central", value: "francecentral" },
  },
  {
    name: "Europe (North)",
    aws: { label: "Europe (Stockholm)", value: "eu-north-1" },
    gcp: { label: "Finland", value: "europe-north1" },
    azure: { label: "Norway East", value: "norwayeast" },
  },
  {
    name: "Asia Pacific (Japan)",
    aws: { label: "Asia Pacific (Tokyo)", value: "ap-northeast-1" },
    gcp: { label: "Tokyo, Japan", value: "asia-northeast1" },
    azure: { label: "Japan East", value: "japaneast" },
  },
  {
    name: "Asia Pacific (Korea)",
    aws: { label: "Asia Pacific (Seoul)", value: "ap-northeast-2" },
    gcp: { label: "Seoul, South Korea", value: "asia-northeast3" },
    azure: { label: "Korea Central", value: "koreacentral" },
  },
  {
    name: "Asia Pacific (Singapore)",
    aws: { label: "Asia Pacific (Singapore)", value: "ap-southeast-1" },
    gcp: { label: "Singapore", value: "asia-southeast1" },
    azure: { label: "Southeast Asia", value: "southeastasia" },
  },
  {
    name: "Asia Pacific (Australia)",
    aws: { label: "Asia Pacific (Sydney)", value: "ap-southeast-2" },
    gcp: { label: "Sydney, Australia", value: "australia-southeast1" },
    azure: { label: "Australia East", value: "australiaeast" },
  },
  {
    name: "Asia Pacific (India)",
    aws: { label: "Asia Pacific (Mumbai)", value: "ap-south-1" },
    gcp: { label: "Mumbai, India", value: "asia-south1" },
    azure: { label: "Central India", value: "centralindia" },
  },
  {
    name: "Asia Pacific (Hong Kong)",
    aws: { label: "Asia Pacific (Hong Kong)", value: "ap-east-1" },
    gcp: { label: "Hong Kong", value: "asia-east2" },
    azure: { label: "East Asia", value: "eastasia" },
  },
  {
    name: "Middle East",
    aws: { label: "Middle East (Bahrain)", value: "me-south-1" },
    gcp: { label: "Doha, Qatar", value: "me-central1" },
    azure: { label: "Qatar Central", value: "qatarcentral" },
  },
  {
    name: "South America",
    aws: { label: "South America (São Paulo)", value: "sa-east-1" },
    gcp: { label: "São Paulo, Brazil", value: "southamerica-east1" },
    azure: { label: "Brazil South", value: "brazilsouth" },
  },
  {
    name: "Africa",
    aws: { label: "Africa (Cape Town)", value: "af-south-1" },
    gcp: null,
    azure: { label: "South Africa North", value: "southafricanorth" },
  },
  {
    name: "Middle East (UAE)",
    aws: { label: "Middle East (UAE)", value: "me-central-1" },
    gcp: { label: "Tel Aviv, Israel", value: "me-west1" },
    azure: { label: "UAE North", value: "uaenorth" },
  },
];

export const comparePaymentTypes = [
  {
    name: "On-Demand / Pay-As-You-Go",
    aws: { label: "On Demand", value: "OnDemand" },
    gcp: { label: "On Demand", value: "OnDemand" },
    azure: { label: "Pay As You Go", value: "payasyougo" },
  },
  {
    name: "Spot / Preemptible / Low Priority",
    aws: { label: "Spot", value: "Spot" },
    gcp: { label: "Spot (Preemptible VM)", value: "Spot" },
    azure: { label: "Spot", value: "spot" }, // Azure supports Spot VMs too
  },
  {
    name: "1-Year Reserved",
    aws: {
      label: "1yr Reserved - All Upfront",
      value: "Reserved1yrStandardAllUpfront",
    },
    gcp: { label: "1-Year Commitment", value: "Commit1Yr" },
    azure: { label: "Reserved 1-Year", value: "reserved1y" },
  },
  {
    name: "3-Year Reserved",
    aws: {
      label: "3yr Reserved - All Upfront",
      value: "Reserved3yrStandardAllUpfront",
    },
    gcp: { label: "3-Year Commitment", value: "Commit3Yr" },
    azure: { label: "Reserved 3-Year", value: "reserved3y" },
  },
  {
    name: "1-Year Convertible / Savings Plan",
    aws: {
      label: "1yr Convertible - All Upfront",
      value: "Reserved1yrConvertibleAllUpfront",
    },
    gcp: { label: "1-Year Commitment (Flexible)", value: "Commit1Yr" },
    azure: { label: "Savings Plan 1-Year", value: "savingsplan1y" },
  },
  {
    name: "3-Year Convertible / Savings Plan",
    aws: {
      label: "3yr Convertible - All Upfront",
      value: "Reserved3yrConvertibleAllUpfront",
    },
    gcp: { label: "3-Year Commitment (Flexible)", value: "Commit3Yr" },
    azure: { label: "Savings Plan 3-Year", value: "savingsplan3y" },
  },
  {
    name: "Sustained / Continuous Use Discount",
    aws: null, // AWS doesn’t have an equivalent sustained discount
    gcp: { label: "Sustained Use 100%", value: "SustainedDiscounts100" },
    azure: null, // Azure covers this through Savings Plans
  },
  {
    name: "Partial Upfront (Reserved Hybrid)",
    aws: {
      label: "1yr Reserved - Partial Upfront",
      value: "Reserved1yrStandardPartialUpfront",
    },
    gcp: null,
    azure: null,
  },
  {
    name: "No Upfront (Reserved Hybrid)",
    aws: {
      label: "1yr Reserved - No Upfront",
      value: "Reserved1yrStandardNoUpfront",
    },
    gcp: null,
    azure: null,
  },
];

export const compareOperatingSystems = [
  {
    name: "Linux / Unix",
    aws: { label: "Linux/Unix", value: "Linux" },
    gcp: { label: "Ubuntu (Generic Linux)", value: "Ubuntu" },
    azure: { label: "Linux", value: "Linux" },
  },
  {
    name: "Windows Server",
    aws: { label: "Windows", value: "Windows" },
    gcp: { label: "Windows Server", value: "Windows" },
    azure: { label: "Windows", value: "Windows" },
  },
  {
    name: "Ubuntu",
    aws: { label: "Ubuntu", value: "Ubuntu" },
    gcp: { label: "Ubuntu", value: "Ubuntu" },
    azure: { label: "Ubuntu", value: "Ubuntu" },
  },
  {
    name: "Red Hat Enterprise Linux (RHEL)",
    aws: { label: "Red Hat Enterprise Linux", value: "RHEL" },
    gcp: { label: "Red Hat Enterprise Linux", value: "RHEL" },
    azure: { label: "Red Hat Enterprise Linux", value: "RHEL" },
  },
  {
    name: "SUSE Linux Enterprise (SLES)",
    aws: { label: "SUSE Linux", value: "SUSE" },
    gcp: { label: "SUSE Linux Enterprise Server", value: "SLES" },
    azure: { label: "SUSE Linux Enterprise", value: "SLES" },
  },
  {
    name: "Debian",
    aws: { label: "Debian", value: "Debian" },
    gcp: { label: "Debian", value: "Debian" },
    azure: { label: "Debian", value: "Debian" },
  },
  {
    name: "CentOS",
    aws: { label: "CentOS", value: "CentOS" },
    gcp: { label: "CentOS", value: "CentOS" },
    azure: { label: "CentOS", value: "CentOS" },
  },
  {
    name: "Rocky Linux",
    aws: null, // AWS doesn’t officially list Rocky as a preset option
    gcp: { label: "Rocky Linux", value: "Rocky" },
    azure: null,
  },
  {
    name: "Container-Optimized OS (COS)",
    aws: null,
    gcp: { label: "Container-Optimized OS", value: "COS" },
    azure: null,
  },
];

export const multipliers: Record<string, number> = {
  "Per Hour": 1,
  "Per Day": 24,
  "Per Month": 24 * 30,
  "Per Year": 24 * 365,
};

export const categoryMapping = {
  generalPurpose: {
    label: "General Purpose",
    aws: ["t4g", "t3", "t3a", "m6g", "m5", "m5a", "m7g"],
    gcp: ["e2", "n2", "n2d"],
    azure: ["D", "Dsv3", "Dasv4", "Dsv5", "Dv5"],
  },
  computePurpose: {
    label: "Compute Purpose",
    aws: ["c7g", "c6g", "c5", "c5a", "c5n"],
    gcp: ["c2", "c2d"],
    azure: ["F", "Fsv2"],
  },
  memoryPurpose: {
    label: "Memory Purpose",
    aws: ["r7g", "r6g", "r5", "r5a", "r5n", "x2idn", "x2iedn"],
    gcp: ["m1", "m2", "m3", "n2-highmem"],
    azure: ["E", "Esv3", "Esv5", "M"],
  },
  storageOptimized: {
    label: "Storage Optimized",
    aws: ["i3", "i3en", "im4gn", "is4gen", "d2", "h1"],
    gcp: ["n2-highcpu-localssd"],
    azure: ["L", "Lasv3"],
  },
  acceleratedComputing: {
    label: "Accelerated Computing",
    aws: ["p4d", "p3", "g5", "inf1", "trn1", "dl1"],
    gcp: ["a2", "t4", "v100", "p100"],
    azure: ["NC", "ND", "NV"],
  },
  highPerformance: {
    label: "High Performance",
    aws: ["hpc6a", "hpc6id", "hpc7g"],
    gcp: ["h3", "c2d-highcpu"],
    azure: ["HB", "HC", "HX"],
  },
};
